// extracted by mini-css-extract-plugin
module.exports = {"Chips":"ChipField_Chips__2P79f"};